import React, { useState, useEffect } from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import download from 'downloadjs'

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import InputLabel from "@material-ui/core/InputLabel";

import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import RangeSlider from 'react-dual-rangeslider';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';
import Button from "@material-ui/core/Button";
import Select from "@material-ui/core/Select";
import fontb from '../../B-NAZANIN.TTF';
import fontb2 from '../../btitr.ttf';
import ReactFontFace from 'react-font-face'
//import page from './lda.html'
//var page= require('./lda.html')
//var htmlDoc = {__html: page};
import { Redirect } from "react-router";
import Typography from "@material-ui/core/Typography";
import Grid from '@material-ui/core/Grid';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
//import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
// import charts from "../Charts/Charts"
import Charts from "../Charts/Charts";
import Users from "../users/users"
import {
    dailySalesChart,
    emailsSubscriptionChart,
    completedTasksChart
} from "../Charts/Charts2";

// import Button from '@material-ui/core/Button';
// import { makeStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
// import Icon from '@material-ui/core/Icon';
import SaveIcon from '@material-ui/icons/Save';
import Slide from '@material-ui/core/Slide';
// const useStyles2 = makeStyles((theme) => ({
//     button: {
//       margin: theme.spacing(1),
//     },
//   }));
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(styles);
let theme2 = createMuiTheme();

// const classes2 = useStyles();
const style = { width: 400, margin: 50 };
theme2.typography.h2 = {
    // fontSize: '1.6rem',
    // '@media (min-width:100px)': {
    // fontSize: 14,
    // },
    // [theme2.breakpoints.down('lg')]: {
    //   fontSize: 19,
    // },
    // [theme2.breakpoints.up('xl')]: {
    //   fontSize: 19,
    // },
    [theme2.breakpoints.up('md')]: {
        fontSize: 25,
    },
    // [theme2.breakpoints.up('xs')]: {
    // fontSize: 1,
    // },
    [theme2.breakpoints.down('sm')]: {
        fontSize: 19,
    },
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function log(value) {
    console.log(value); //eslint-disable-line
}

let fontConfig = {

    file: [
        {
            fontFamily: 'Bnazanin',
            fontStyle: 'normal',
            fontWeight: 400,
            // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
            file: fontb,
            fontType: 'truetype',
            // fileLocal: 'Bangers Regular'
        },
        {
            fontFamily: 'Btitr',
            fontStyle: 'normal',
            fontWeight: 400,
            // unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215',
            file: fontb2,
            fontType: 'truetype',
            // fileLocal: 'Bangers Regular'
        }


    ]
}
const MatchMediaWrapper = ({ mobileContent, desktopContent }) => {
    const [isNarrowScreen, setIsNarrowScreen] = useState(false)
    useEffect(() => {
        const mediaWatcher = window.matchMedia("(max-width: 1230px)")
        setIsNarrowScreen(mediaWatcher.matches);

        function updateIsNarrowScreen(e) {
            setIsNarrowScreen(e.matches);
        }

        if (mediaWatcher.addEventListener) {
            mediaWatcher.addEventListener('change', updateIsNarrowScreen)
            return function cleanup() {
                mediaWatcher.removeEventListener('change', updateIsNarrowScreen)
            }
        } else {
            mediaWatcher.addListener(updateIsNarrowScreen)
            return function cleanup() {
                mediaWatcher.removeListener(updateIsNarrowScreen)
            }
        }
    })
    return isNarrowScreen ? mobileContent : desktopContent;
}

class LDA extends React.Component {
    constructor(props) {
        super(props);
        // if (props.location.state){
        this.state = {
            // checkedPos1: null,
            // checkedPos2:null,
            classes: makeStyles(styles),
            input: [],
            action: false,
            category: null,
            checked1: false,
            checked2: false,
            checked3: false,
            setChecked: false,
            min: 1380,
            max: 1399,
            value2: 1390,
            value4: 'زبان',
            imageuri: null,
            response: null,
            ht: null,
            NTopic: 0,
            NWord: 0,
            ShowImage: null,
            Load: false,
            index_get_sample: null,
            // token: props.location.state.token,
            // Email: props.location.state.email,
            UserName: "",
            token: "",
            NSample: 0,
            samples: null,
            open: false,
            open2: false,
            NTopicsExist: false,
            NTopics: null,
            years: null

        };

        // }
        // else
        //     this.state = {
        //         data: '',
        //         token: 1,
        //         UserName: 1,
        //     };


        this.handleChange3 = this.handleChange3.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.handleChange = this.handleChange.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
    }

    onSliderChange = value => {
        log(value);
    };
    closest(num, arr) {
        var curr = arr[0].year;
        var diff = Math.abs(num - curr);
        for (var val = 0; val < arr.length; val++) {
            var newdiff = Math.abs(num - arr[val].year);
            if (newdiff < diff) {
                diff = newdiff;
                curr = arr[val].year;
            }
        }
        return curr;
    }

    onMinChange = e => {
        this.setState({
            min: e.target.value,
        });
    };
    onValueChange = e => {
        this.setState({
            value2: +e.target.value || 0,
        });
    };
    handleChange = e => {
        if (e.target.value >= 0) {
            this.setState({
                NTopic: +e.target.value || 0,
            });
        }
    };
    handleChange1 = e => {
        if (e.target.value >= 0) {
            if (e.target.value <= 20) {
                this.setState({
                    NWord: +e.target.value || 0,
                });
            }

        }

    };
    onMaxChange = e => {
        this.setState({
            max: e.target.value,
        });
    };

    handleChange3(event) {
        console.log("event.target.value")
        console.log(event.target.value)
        //fetch("http://conalysis.ihcs.ac.ir:8080/determine_year", {
        fetch("http://conalysis.ihcs.ac.ir:8080/determine_year", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: event.target.value,
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    years: responseJson,
                })
                console.log(responseJson);


            })
            .catch((error) => {
                console.log(error);
            });
        //         fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
        fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: event.target.value,
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {

                console.log(responseJson);
                if (responseJson.exist) {

                    this.setState({
                        NTopics: responseJson.topic_ids,
                        NTopicsExist: true,
                        NTopic: responseJson.topic_ids[0].ntopic,
                    })

                } else {
                    this.setState({
                        NTopicsExist: false,
                    })

                }


            })
            .catch((error) => {
                console.log(error);
            });
        // console.log(this.state.value);
        this.setState({ value4: event.target.value });

    }

    handleClickOpen2(type1, topic_id, topic_id2, option, index) {
        if (type1 == 1) {
            //            fetch("http://conalysis.ihcs.ac.ir:8080/get_similarity", {

            fetch("http://conalysis.ihcs.ac.ir:8080/get_similarity", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({

                    type: 1,
                    topic_id: option[0] + ",type0",
                    topic_number: option[0],
                    subject: option[5],
                    ntopic: option[6],                   // article_id:0,
                    // type:'1',
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("responseJson");
                    console.log(responseJson);
                    this.setState({
                        open2: true,
                        similarity: responseJson,
                        index_get_sample: index + 1
                    })


                })
                .catch((error) => {
                    console.log(error);
                });


        } else {
            //            fetch("http://conalysis.ihcs.ac.ir:8080/get_similarity", {
            fetch("http://conalysis.ihcs.ac.ir:8080/get_similarity", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    type: 2,
                    // topic_id: topic_id+","+"",
                    // article_id:article_id,
                    topic_id: topic_id,
                    topic_number: topic_id2,
                    subject: option[5],
                    ntopic: option[6],
                    index_get_sample: index + 1// type:'1',
                }),
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("responseJson");
                    console.log(responseJson);
                    this.setState({
                        // open:true,
                        similarity: responseJson
                    })
                })
                .catch((error) => {
                    console.log(error);
                });

        }

    };


    handleClickOpen(option, NSample, index) {
        console.log(option)
        console.log(index)
        //        fetch("http://conalysis.ihcs.ac.ir:8080/get_samples", {

        fetch("http://conalysis.ihcs.ac.ir:8080/get_samples", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // NSample: this.state.input_sample[index],
                topic_id: option[0],
                subject: option[5],
                ntopic: option[6],
                NSample: NSample,
                // topic_id: topic_id,
                // type:'1',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                console.log("responseJson");
                console.log(responseJson);
                this.setState({
                    open: true,
                    samples: responseJson,
                    index_get_sample: index + 1
                })
            })
            .catch((error) => {
                console.log(error);
            });


        // setOpen(true);
    };

    handleClose() {
        this.setState({
            open: false
        })
    };

    handleClose2() {
        this.setState({
            open2: false
        })
    };

    handleChange10 = e => {
        if (e.target.value >= 0) {
            this.setState({
                NSample: +e.target.value || 0,
            });
        }
    };

    handleSubmit(event) {
        alert('Your favorite flavor is: ' + this.state.value);
        event.preventDefault();
    }

    // handleChange(event) {
    //     this.setState({ NTopic: event.target.value });
    //   }

    //   handleChange1(event) {
    //     this.setState({ NWord: event.target.value });
    //   }
    async componentDidMount() {
        //        await fetch("http://conalysis.ihcs.ac.ir:8080/determine_year", {

        await fetch("http://conalysis.ihcs.ac.ir:8080/determine_year", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subject: 'زبان',
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                this.setState({
                    years: responseJson,
                })
                console.log(responseJson);


            })
            .catch((error) => {
                console.log(error);
            });
        //        await fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {

        await fetch("http://conalysis.ihcs.ac.ir:8080/determine_ntopic", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                // label: this.state.input[index],
                subject: 'زبان',
                // topic_version:value.topics_version,
                // email:this.props.location.state.email
            }),
        })
            .then((response) => response.json())
            .then((responseJson) => {
                //   console.log("hello")
                console.log(responseJson);
                if (responseJson.exist) {

                    this.setState({
                        NTopics: responseJson.topic_ids,
                        NTopicsExist: true,
                        NTopic: responseJson.topic_ids[0].ntopic,
                    })
                } else {
                    this.setState({
                        NTopicsExist: false,
                    })

                }


            })
            .catch((error) => {
                console.log(error);
            });


    }

    openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    render() {
        console.log(this.props.location.state)
        const {
            state: { domain, values, update, reversed },
        } = this;
        // if (this.state.token !== 1){
        return (

            <div>
                <GridContainer>
                    <Button
                        className="button"
                        style={{
                            marginTop: "-5%",
                            marginRight: "95%",
                            borderRadius: "20px",
                            fontFamily: "Btitr",
                            fontSize: 16,
                            width: "2%",
                            height: "3%",
                            backgroundColor: "rgb(0,191,214)"
                        }}
                        onClick={() => {
                            this.setState({
                                action: true
                            })
                        }

                        }
                    >
                        خروج
                    </Button>
                    {
                        this.state.action ? <div>{this.check22()}</div> : null
                    }
                    {/* <div style={{marginTop:"-5%",marginRight:"97%"}}>hello</div> */}
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={this.state.classes.cardTitleWhite}
                                    style={{ fontFamily: 'Bnazanin', fontSize: 29 }}>تحلیل موضوعی متن</h4>
                                {/* <p className={this.state.classes.cardCategoryWhite}> */}
                                {/*New employees on 15th September, 2016*/}
                                {/* </p> */}
                            </CardHeader>
                            <CardBody>

                                <div style={{ flexDirection: "row", display: "flex" }}>
                                    <div style={{ width: "40%" }}>
                                        {/*<form onSubmit={this.handleSubmit}>*/}
                                        {/*    <label>*/}
                                        {/*        Pick your favorite flavor:*/}
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select">حوزه علمی:</InputLabel>
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.value4} onChange={this.handleChange3}>
                                            <option value="اقتصاد"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>اقتصاد
                                            </option>
                                            <option value="ادبیات"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>ادبیات
                                            </option>
                                            <option value="تربیت بدنی"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>تربیت بدنی
                                            </option>
                                            <option value="تاریخ" style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>تاریخ
                                            </option>
                                            <option value="جغرافیا"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>جغرافیا
                                            </option>
                                            <option value="حقوق" style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>حقوق
                                            </option>
                                            <option value="روانشناسی علوم تربیتی"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>روانشناسی و علوم تربیتی
                                            </option>
                                            <option value="زبان" style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>زبان‌شناسی
                                            </option>
                                            {/* <option value="سیاست" style={{fontFamily:'Bnazanin',fontSize:25}}>سیاست</option> */}
                                            {/* <option value="علوم انسانی" style={{fontFamily:'Bnazanin',fontSize:25}}>علوم انسانی</option> */}
                                            <option value="علوم اسلامی"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>علوم اسلامی
                                            </option>
                                            <option value="علوم کتابداری"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>علوم کتابداری
                                            </option>
                                            <option value="علوم اجتماعی ارتباطات"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>علوم اجتماعی و ارتباطات
                                            </option>
                                            <option value="علوم سیاسی روابط الملل"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>علوم سیاسی و روابط بین‌الملل
                                            </option>
                                            <option value="فلسفه منطق"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>فلسفه و منطق
                                            </option>
                                            <option value="مدیریت حسابداری"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>مدیریت و حسابداری
                                            </option>

                                            <option value="مطالعات هنر"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>مطالعات هنر
                                            </option>


                                            <option value="مطالعات زنان"
                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>مطالعات زنان
                                            </option>


                                        </select>
                                    </div>
                                </div>
                                <Grid Container fluid style={{ justifyContent: 'row', display: "flex", width: "100%" }}>
                                    <Grid item xs={9} sm={9} md={9} lg={9}>
                                        <p style={{ marginTop: "4%", fontFamily: 'Bnazanin', fontSize: 25 }}>
                                            تاریخ انتشار متون علمی:
                                        </p>
                                    </Grid>
                                </Grid>


                                <div style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    // backgroundColor:"blue",
                                    fontSize: 19,
                                    alignItems: "center",
                                    width: "100%",
                                    // background:"black"

                                }}>

                                    <Checkbox
                                        checked={this.state.checked1}

                                        onChange={(e) => {
                                            this.setState({
                                                checked1: e.target.checked
                                            }, () => {
                                                if (this.state.checked1) {
                                                    this.setState({
                                                        checked2: false,
                                                        checked3: false,
                                                    });
                                                }
                                            })

                                        }}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{ fontFamily: 'Bnazanin' }}> بازه زمانی

                                        </Typography>
                                    </ThemeProvider>

                                    <label style={{
                                        fontFamily: 'Bnazanin',
                                        fontSize: 25,
                                        marginRight: "2%",
                                        color: "black"
                                    }}>از
                                    </label>
                                    <Grid xs={2} sm={1} md={1} lg={1} style={{ marginRight: "1%" }}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select" />
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.min} onChange={this.onMinChange}>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((item, index) => {

                                                        return (
                                                            <option value={item}
                                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>{item}
                                                            </option>

                                                        )
                                                    })
                                                    : null
                                            }




                                        </select>

                                        {/*<Input disabled={!this.state.checked1}*/}
                                        {/*       style={{width: "100%",fontFamily: "Bnazanin",fontSize: 19}}*/}
                                        {/*       type="number" value={this.state.min}*/}
                                        {/*       onChange={this.onMinChange}/>*/}
                                        {/* </Grid> */}
                                    </Grid>
                                    <label style={{
                                        // width: "15%",
                                        color: "black",
                                        fontFamily: 'Bnazanin', fontSize: 25,
                                        marginRight: "5%"
                                    }}>تا </label>
                                    <Grid item xs={2} sm={1} md={1} lg={1} style={{ marginRight: "1%" }}>
                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select" disabled={!this.state.checked1} />
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.max} onChange={this.onMaxChange}>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((item, index) => {

                                                        return (
                                                            <option value={item}
                                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>{item}
                                                            </option>

                                                        )
                                                    })
                                                    : null
                                            }




                                        </select>
                                        {/*<input disabled={!this.state.checked1}*/}
                                        {/*       style={{width: "100%",fontFamily: "Bnazanin",fontSize: 19}}*/}
                                        {/*       type="number" value={this.state.max}*/}
                                        {/*       onChange={this.onMaxChange}/>*/}
                                    </Grid>
                                </div>
                                <div style={{
                                    marginTop: "3%",
                                    // height: "40%",
                                    flexDirection: "row",
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    <Checkbox
                                        checked={this.state.checked2}
                                        onChange={(e) => {
                                            this.setState({
                                                checked2: e.target.checked
                                            }, () => {
                                                if (this.state.checked2) {
                                                    this.setState({
                                                        checked1: false,
                                                        checked3: false,
                                                    });
                                                }
                                            })
                                        }}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{ fontFamily: 'Bnazanin' }}> سال

                                        </Typography>
                                    </ThemeProvider>

                                    <Grid item xs={2} sm={2} md={1} lg={1} style={{ marginRight: "1%" }}>
                                        {/* <input disabled={!this.state.checked1} */}

                                        <InputLabel style={{
                                            width: "100%",
                                            fontSize: 25,
                                            fontFamily: 'Bnazanin',
                                            color: "black"
                                        }} htmlFor="select" />
                                        <select style={{
                                            fontFamily: 'Bnazanin',
                                            width: "auto",
                                            fontSize: 19,
                                            marginTop: "5%"
                                        }} value={this.state.value2} onChange={this.onValueChange}>
                                            {
                                                this.state.years ?
                                                    this.state.years.map((item, index) => {

                                                        return (
                                                            <option value={item}
                                                                style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>{item}
                                                            </option>

                                                        )
                                                    })
                                                    : null
                                            }




                                        </select>
                                        {/*<input disabled={!this.state.checked2}*/}
                                        {/*       style={{width: "100%",fontFamily: "Bnazanin",fontSize: 19}}*/}
                                        {/*       type="number" value={this.state.value2}*/}
                                        {/*       onChange={this.onValueChange}/>*/}
                                    </Grid>

                                </div>

                                <div style={{

                                    flexDirection: "row",
                                    display: "flex",
                                    // marginRight: '4%',
                                    // fontSize: 19
                                    // display: "flex",
                                    alignItems: "center",
                                }}>
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{ fontFamily: 'Bnazanin' }}> تعداد موضوع:

                                        </Typography>
                                    </ThemeProvider>

                                    <Grid item xs={1} sm={1} md={1} lg={1} style={{ marginRight: "1%" }}>
                                        <select style={{
                                            width: "auto",
                                            fontSize: 19,
                                            fontFamily: 'Bnazanin',
                                            marginTop: "3%"
                                        }}
                                            value={this.state.NTopic}
                                            onChange={this.handleChange}
                                        >
                                            {
                                                (this.state.NTopicsExist) ?
                                                    this.state.NTopics.map((option, index) => {
                                                        return (
                                                            <option value={option.ntopic} style={{
                                                                fontFamily: 'Bnazanin',
                                                                fontSize: 25
                                                            }}>{option.ntopic}</option>

                                                        )


                                                    })


                                                    :
                                                    <option style={{ fontFamily: 'Bnazanin', fontSize: 25 }}>موجود
                                                        نیست</option>


                                            }


                                        </select>


                                    </Grid>
                                    {/* <TextField
                                                       style={{ height: "40%", marginTop: "1.5%",border:"",border:'1px solid black'}}
                                                    //    type="number" value={this.state.min}
                                                       onChange={this.handleChange}/> */}
                                    {/*</div>*/}
                                    {/* <label style={{
                                                    color:"black",
                                                    // width: "25%",
                                                    marginTop: ".5%",
                                                    fontFamily:'Bnazanin',fontSize:25,
                                                    marginRight: "3%"
                                                }}>تعداد کلمات:</label> */}
                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{
                                            fontFamily: 'Bnazanin',
                                            marginRight: "3%",
                                            marginTop: ".5%",
                                        }}> تعداد واژه‌های کلیدی:

                                        </Typography>
                                    </ThemeProvider>


                                    <Grid item xs={1} sm={1} md={1} lg={1} style={{ marginRight: "1%" }}>
                                        <input
                                            style={{ width: "100%", marginRight: "1%", fontFamily: "Bnazanin", fontSize: 19 }}
                                            type="number" value={this.state.NWord}
                                            onChange={this.handleChange1} />
                                    </Grid>
                                </div>
                                <div style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    // marginRight: '4%',
                                    // fontSize: 19
                                    // display: "flex",
                                    alignItems: "center",
                                }}>
                                    <Checkbox
                                        checked={this.state.checked3}
                                        onChange={(e) => {
                                            this.setState({
                                                checked3: e.target.checked
                                            }, () => {
                                                if (this.state.checked3) {
                                                    this.setState({
                                                        checked1: false,
                                                        checked2: false,
                                                    });
                                                }
                                            })
                                        }}
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />

                                    <ThemeProvider theme={theme2}>
                                        <Typography variant="h2" style={{ fontFamily: 'Bnazanin' }}> نمایش بصری

                                        </Typography>
                                    </ThemeProvider>
                                </div>
                                <div
                                    style={{ marginTop: "6%", width: "100%", display: 'flex', justifyContent: "center" }}>
                                    <Button
                                        className="button"
                                        style={{
                                            fontFamily: "Btitr",
                                            fontSize: 19,
                                            width: "20%",
                                            backgroundColor: "rgb(151,75,177)"
                                        }}
                                        onClick={() => this.sentLDAData()}
                                    // onClick={this.handleSubmit}

                                    >
                                        دریافت اطلاعات
                                    </Button>
                                </div>
                                {this.state.Load ?
                                    <div style={{ width: "100%", display: 'flex', justifyContent: "center" }}>
                                        {/*<LinearProgress />*/}
                                        <CircularProgress size={70} />
                                    </div> : [
                                        (this.state.response ? this.state.response.map((option1, index) => {
                                            console.log(this.state.response.length)

                                            // if (index !== this.state.response.length - 1) {
                                            if (typeof option1[0] !== 'string') {

                                                return (

                                                    // )
                                                    option1[1].map((option, index2) => {

                                                        // var words=[]
                                                        // option.map((option1, index1) => {
                                                        //     words.push(option1[0])
                                                        // })
                                                        // var prop=[]
                                                        // option.map((option2, index1) => {
                                                        //     prop.push(option2[2].toFixed(3))
                                                        // })
                                                        // var freq=[]
                                                        // option.map((option3, index1) => {
                                                        //     freq.push(option3[3].toFixed(0))
                                                        // })
                                                        //    console.log(option)
                                                        return (
                                                            <div>

                                                                <Card>
                                                                    <CardHeader>
                                                                        <div style={{
                                                                            position: "relative",
                                                                            direction: "ltr"
                                                                        }}>

                                                                            {/*<Charts words={option[2]} freq={option[4]}*/}
                                                                            {/*        prop={option[3]} topic_id={option[1]}/>*/}
                                                                            <Charts style={{ minWidth: 300 }} words={option[1].slice(0, this.state.NWord)} freq={option[3].slice(0, this.state.NWord)}
                                                                                prop={option[2].slice(0, this.state.NWord)}
                                                                                topic_id={index + 1} />

                                                                        </div>


                                                                        <MatchMediaWrapper
                                                                            mobileContent={
                                                                                <div>
                                                                                    <div className="contaner_buttons">
                                                                                        <label
                                                                                            style={{
                                                                                                color: "black",
                                                                                                fontFamily: 'Bnazanin',
                                                                                                fontSize: 19,
                                                                                            }}> برچسب:</label>
                                                                                        <input style={{
                                                                                            marginRight: "2%",
                                                                                            fontFamily: 'Bnazanin',
                                                                                            fontSize: 19,
                                                                                        }}
                                                                                            disabled
                                                                                            value={option1[2]}
                                                                                        />
                                                                                    </div>
                                                                                    <div className="contaner_buttons">
                                                                                        <label style={{
                                                                                            color: "black",
                                                                                            fontFamily: 'Bnazanin',
                                                                                            fontSize: 19,
                                                                                        }}> تعداد
                                                                                            شواهد:</label>


                                                                                        <input
                                                                                            value={this.state.input[index]}
                                                                                            style={{ marginRight: "1%", fontFamily: "Bnazanin", fontSize: 19 }}
                                                                                            type="number"
                                                                                            //    value={this.state.NSample}
                                                                                            onChange={(e) => {
                                                                                                if (e.target.value >= 0 && e.target.value <= 50) {
                                                                                                    var input1 = [...this.state.input];

                                                                                                    input1.splice(index, 1, e.target.value);
                                                                                                    this.setState({
                                                                                                        input: input1
                                                                                                    });
                                                                                                }
                                                                                                console.log(this.state.input[index])
                                                                                            }} />

                                                                                        {/* </div>                                                      */}

                                                                                        <div className="submit_button">
                                                                                            <Button variant="outlined"
                                                                                                color="primary"
                                                                                                style={{
                                                                                                    marginRight: 5,
                                                                                                    fontFamily: 'Bnazanin',
                                                                                                    fontSize: 19,
                                                                                                }}
                                                                                                onClick={() => this.handleClickOpen(option, this.state.input[index], option1[0])}>
                                                                                                مشاهده شواهد
                                                                                            </Button>
                                                                                            <Dialog fullScreen
                                                                                                open={this.state.open}
                                                                                                onClose={() => this.handleClose()}
                                                                                                TransitionComponent={Transition}>
                                                                                                <AppBar
                                                                                                    style={{ position: 'relative' }}>
                                                                                                    <Toolbar>
                                                                                                        <IconButton
                                                                                                            edge="start"
                                                                                                            color="inherit"
                                                                                                            onClick={() => this.handleClose()}
                                                                                                            aria-label="close">
                                                                                                            <CloseIcon />
                                                                                                        </IconButton>
                                                                                                        <Typography
                                                                                                            variant="h6"
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                textAlign: "right",
                                                                                                                fontFamily: "Bnazanin",
                                                                                                            }}>
                                                                                                            {this.state.samples ?
                                                                                                                <div>{'  موضوع' + this.state.index_get_sample}</div> : null


                                                                                                            }
                                                                                                        </Typography>
                                                                                                        {/* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}> save</Button> */}
                                                                                                    </Toolbar>
                                                                                                </AppBar>
                                                                                                <Card>
                                                                                                    <CardHeader>


                                                                                                        <div>
                                                                                                            {this.state.samples ? this.state.samples[1].map((value, index3) => {
                                                                                                                return (
                                                                                                                    <Card>
                                                                                                                        <CardHeader>
                                                                                                                            <div
                                                                                                                                style={{
                                                                                                                                    width: '100%',
                                                                                                                                    textAlign: "right",
                                                                                                                                    fontWeight: 'bold',
                                                                                                                                    fontFamily: "Btitr",
                                                                                                                                    fontSize: 20,
                                                                                                                                }}>
                                                                                                                                {":عنوان"}
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                style={{
                                                                                                                                    textAlign: "right",
                                                                                                                                    fontFamily: "Bnazanin",
                                                                                                                                    fontSize: 22,
                                                                                                                                }}>
                                                                                                                                {value[1]}
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                style={{
                                                                                                                                    width: "100%",
                                                                                                                                    textAlign: "right",
                                                                                                                                    // fontWeight: 'bold',
                                                                                                                                    fontFamily: "Btitr",
                                                                                                                                    fontSize: 20,
                                                                                                                                }}>
                                                                                                                                {":چکیده"}
                                                                                                                            </div>
                                                                                                                            <div
                                                                                                                                style={{
                                                                                                                                    width: "100%",
                                                                                                                                    textAlign: "right",
                                                                                                                                    fontFamily: "Bnazanin",
                                                                                                                                    fontSize: 22,
                                                                                                                                }}>
                                                                                                                                {value[2]}
                                                                                                                            </div>
                                                                                                                            {/*    <div*/}
                                                                                                                            {/*    style={{textAlign: "right"}}>*/}
                                                                                                                            {/*{value[0]}*/}
                                                                                                                            {/*    </div>*/}

                                                                                                                        </CardHeader>
                                                                                                                    </Card>

                                                                                                                )
                                                                                                            }) : null

                                                                                                            }
                                                                                                        </div>
                                                                                                    </CardHeader>
                                                                                                </Card>
                                                                                            </Dialog>
                                                                                        </div>

                                                                                    </div>
                                                                                    <div style={{ marginTop: 10 }}>

                                                                                        <Button variant="outlined"
                                                                                            color="primary"
                                                                                            style={{
                                                                                                marginRight: 5,
                                                                                                fontSize: 19,
                                                                                                fontFamily: 'Bnazanin'
                                                                                            }}
                                                                                            onClick={() => this.handleClickOpen2(1, option[0], option[0], option, option1[0])}>
                                                                                            مقالات مشابه
                                                                                        </Button>
                                                                                        <Dialog fullScreen
                                                                                            open={this.state.open2}
                                                                                            onClose={() => this.handleClose2()}
                                                                                            TransitionComponent={Transition}>
                                                                                            <AppBar
                                                                                                style={{ position: 'relative' }}>
                                                                                                <Toolbar>
                                                                                                    <IconButton
                                                                                                        edge="start"
                                                                                                        color="inherit"
                                                                                                        onClick={() => this.handleClose2()}
                                                                                                        aria-label="close">
                                                                                                        <CloseIcon />
                                                                                                    </IconButton>
                                                                                                    <Typography
                                                                                                        variant="h6"
                                                                                                        style={{
                                                                                                            width: '100%',
                                                                                                            textAlign: "right",
                                                                                                            fontFamily: "Btitr",
                                                                                                            fontSize: 20,
                                                                                                        }}>
                                                                                                        {
                                                                                                            this.state.similarity ?
                                                                                                                <div>{'  موضوع' + this.state.index_get_sample}</div> : null
                                                                                                            // <div>{ '  موضوع' +option[1]}</div>
                                                                                                        }
                                                                                                    </Typography>
                                                                                                    {/* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}>save</Button> */}
                                                                                                </Toolbar>
                                                                                            </AppBar>
                                                                                            <div>
                                                                                                {this.state.similarity ? this.state.similarity.map((value, index3) => {
                                                                                                    if (index3 != 0) {
                                                                                                        return (
                                                                                                            <Card>
                                                                                                                <CardHeader>
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            width: '100%',
                                                                                                                            textAlign: "right",
                                                                                                                            // fontWeight: 'bold',
                                                                                                                            fontFamily: "Btitr",
                                                                                                                            fontSize: 22,
                                                                                                                        }}>
                                                                                                                        {":عنوان"}
                                                                                                                    </div>
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            textAlign: "right",
                                                                                                                            fontFamily: "Bnazanin",
                                                                                                                            fontSize: 22,
                                                                                                                        }}>
                                                                                                                        {value[0][1]}
                                                                                                                    </div>
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            textAlign: "right",
                                                                                                                            fontWeight: 'bold',
                                                                                                                            fontFamily: "Btitr",
                                                                                                                            fontSize: 22,
                                                                                                                        }}>
                                                                                                                        {":چکیده"}
                                                                                                                    </div>
                                                                                                                    <div
                                                                                                                        style={{
                                                                                                                            width: "100%",
                                                                                                                            textAlign: "right",
                                                                                                                            fontFamily: "Bnazanin",
                                                                                                                            fontSize: 22,
                                                                                                                        }}>
                                                                                                                        {value[0][2]}
                                                                                                                    </div>
                                                                                                                    <Button
                                                                                                                        variant="outlined"
                                                                                                                        color="primary"
                                                                                                                        style={{
                                                                                                                            marginRight: 5, fontFamily: "Btitr",
                                                                                                                            fontSize: 22,
                                                                                                                        }}
                                                                                                                        onClick={() => this.handleClickOpen2(0, value[0][0].toString() + "," + value[1], this.state.similarity[0], option)}>
                                                                                                                        انتخاب
                                                                                                                    </Button>
                                                                                                                    {/* <div style={{textAlign:"right"}}> */}
                                                                                                                    {/* {value[0]} */}
                                                                                                                    {/* </div> */}

                                                                                                                </CardHeader>
                                                                                                            </Card>

                                                                                                        )
                                                                                                    }
                                                                                                }) : null

                                                                                                }
                                                                                            </div>
                                                                                            {/* </CardHeader> */}
                                                                                            {/* </Card> */}
                                                                                        </Dialog>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            desktopContent={

                                                                                <div>
                                                                                    <div style={{
                                                                                        flexDirection: 'row',
                                                                                        alignItems: "center",
                                                                                        display: 'flex',
                                                                                        width: "100%"
                                                                                    }}>
                                                                                        <div style={{
                                                                                            flexDirection: 'row',
                                                                                            alignItems: "center",
                                                                                            display: 'flex'
                                                                                        }}><label
                                                                                            style={{
                                                                                                color: "black",
                                                                                                fontFamily: 'Bnazanin',
                                                                                                fontSize: 19,
                                                                                            }}> برچسب:</label>
                                                                                            <input style={{
                                                                                                marginRight: "2%",
                                                                                                fontFamily: 'Bnazanin',
                                                                                                fontSize: 19,
                                                                                            }}
                                                                                                disabled
                                                                                                value={option1[2]}
                                                                                            />
                                                                                        </div>
                                                                                        <div style={{
                                                                                            marginRight: "5%",
                                                                                            flexDirection: 'row',
                                                                                            alignItems: "center",
                                                                                            display: 'flex',
                                                                                            width: "40%"
                                                                                        }}>
                                                                                            <label style={{
                                                                                                color: "black",
                                                                                                fontFamily: 'Bnazanin',
                                                                                                fontSize: 19,
                                                                                            }}> تعداد
                                                                                                شواهد:</label>


                                                                                            <input
                                                                                                value={this.state.input[index]}
                                                                                                style={{ marginRight: "1%", fontFamily: "Bnazanin", fontSize: 19 }}
                                                                                                type="number"
                                                                                                //    value={this.state.NSample}
                                                                                                onChange={(e) => {
                                                                                                    if (e.target.value >= 0 && e.target.value <= 50) {
                                                                                                        var input1 = [...this.state.input];

                                                                                                        input1.splice(index, 1, e.target.value);
                                                                                                        this.setState({
                                                                                                            input: input1
                                                                                                        });
                                                                                                    }
                                                                                                    console.log(this.state.input[index])
                                                                                                }} />

                                                                                            {/* </div>                                                      */}

                                                                                            <div className="submit_button">
                                                                                                <Button variant="outlined"
                                                                                                    color="primary"
                                                                                                    style={{
                                                                                                        marginRight: 5,
                                                                                                        fontFamily: 'Bnazanin',
                                                                                                        fontSize: 19,
                                                                                                    }}
                                                                                                    onClick={() => this.handleClickOpen(option, this.state.input[index], option1[0])}>
                                                                                                    مشاهده شواهد
                                                                                                </Button>
                                                                                                <Dialog fullScreen
                                                                                                    open={this.state.open}
                                                                                                    onClose={() => this.handleClose()}
                                                                                                    TransitionComponent={Transition}>
                                                                                                    <AppBar
                                                                                                        style={{ position: 'relative' }}>
                                                                                                        <Toolbar>
                                                                                                            <IconButton
                                                                                                                edge="start"
                                                                                                                color="inherit"
                                                                                                                onClick={() => this.handleClose()}
                                                                                                                aria-label="close">
                                                                                                                <CloseIcon />
                                                                                                            </IconButton>
                                                                                                            <Typography
                                                                                                                variant="h6"
                                                                                                                style={{
                                                                                                                    width: '100%',
                                                                                                                    textAlign: "right",
                                                                                                                    fontFamily: "Btitr",
                                                                                                                    fontSize: 20,
                                                                                                                }}>
                                                                                                                {this.state.samples ?
                                                                                                                    <div>{'  موضوع' + this.state.index_get_sample}</div> : null


                                                                                                                }
                                                                                                            </Typography>
                                                                                                            {/* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}>save</Button> */}
                                                                                                        </Toolbar>
                                                                                                    </AppBar>
                                                                                                    <Card>
                                                                                                        <CardHeader>


                                                                                                            <div>
                                                                                                                {this.state.samples ? this.state.samples[1].map((value, index3) => {
                                                                                                                    return (
                                                                                                                        <Card>
                                                                                                                            <CardHeader>
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        width: '100%',
                                                                                                                                        textAlign: "right",
                                                                                                                                        fontWeight: 'bold',
                                                                                                                                        fontSize: 22,
                                                                                                                                        fontFamily: 'Btitr'
                                                                                                                                    }}>
                                                                                                                                    {":عنوان"}
                                                                                                                                </div>
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        textAlign: "right", fontSize: 22,
                                                                                                                                        fontFamily: 'Bnazanin'
                                                                                                                                    }}>
                                                                                                                                    {value[1]}
                                                                                                                                </div>
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        width: "100%",
                                                                                                                                        textAlign: "right",
                                                                                                                                        fontWeight: 'bold',
                                                                                                                                        fontSize: 22,
                                                                                                                                        fontFamily: 'Btitr'
                                                                                                                                    }}>
                                                                                                                                    {":چکیده"}
                                                                                                                                </div>
                                                                                                                                <div
                                                                                                                                    style={{
                                                                                                                                        width: "100%",
                                                                                                                                        textAlign: "right", fontSize: 22,
                                                                                                                                        fontFamily: 'Bnazanin'
                                                                                                                                    }}>
                                                                                                                                    {value[2]}
                                                                                                                                </div>

                                                                                                                            </CardHeader>
                                                                                                                        </Card>

                                                                                                                    )
                                                                                                                }) : null

                                                                                                                }
                                                                                                            </div>
                                                                                                        </CardHeader>
                                                                                                    </Card>
                                                                                                </Dialog>
                                                                                            </div>

                                                                                        </div>
                                                                                        <div style={{ marginRight: 10 }}>

                                                                                            <Button variant="outlined"
                                                                                                color="primary"
                                                                                                style={{
                                                                                                    marginRight: 5,
                                                                                                    fontSize: 19,
                                                                                                    fontFamily: 'Bnazanin'
                                                                                                }}
                                                                                                onClick={() => this.handleClickOpen2(1, option[1], option[1], option, option1[0])}>
                                                                                                مقالات مشابه
                                                                                            </Button>
                                                                                            <Dialog fullScreen
                                                                                                open={this.state.open2}
                                                                                                onClose={() => this.handleClose2()}
                                                                                                TransitionComponent={Transition}>
                                                                                                <AppBar
                                                                                                    style={{ position: 'relative' }}>
                                                                                                    <Toolbar>
                                                                                                        <IconButton
                                                                                                            edge="start"
                                                                                                            color="inherit"
                                                                                                            onClick={() => this.handleClose2()}
                                                                                                            aria-label="close">
                                                                                                            <CloseIcon />
                                                                                                        </IconButton>
                                                                                                        <Typography
                                                                                                            variant="h6"
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                textAlign: "right",
                                                                                                                fontSize: 19,
                                                                                                                fontFamily: 'Btitr'
                                                                                                            }}>
                                                                                                            {
                                                                                                                this.state.similarity ?
                                                                                                                    <div>{'  موضوع' + this.state.index_get_sample}</div> : null
                                                                                                                // <div>{ '  موضوع' +option[1]}</div>
                                                                                                            }
                                                                                                        </Typography>
                                                                                                        {/* <Button autoFocus color="inherit" onClick={()=>this.handleClose()}>save</Button> */}
                                                                                                    </Toolbar>
                                                                                                </AppBar>
                                                                                                <div>
                                                                                                    {this.state.similarity ? this.state.similarity.map((value, index3) => {
                                                                                                        if (index3 != 0) {
                                                                                                            return (
                                                                                                                <Card>
                                                                                                                    <CardHeader>
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: '100%',
                                                                                                                                textAlign: "right",
                                                                                                                                fontWeight: 'bold',
                                                                                                                                fontSize: 22,
                                                                                                                                fontFamily: 'Btitr'
                                                                                                                            }}>
                                                                                                                            {":عنوان"}
                                                                                                                        </div>
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                textAlign: "right",
                                                                                                                                fontSize: 22,
                                                                                                                                fontFamily: 'Bnazanin'
                                                                                                                            }}>
                                                                                                                            {value[0][1]}
                                                                                                                        </div>
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                textAlign: "right",
                                                                                                                                fontWeight: 'bold',
                                                                                                                                fontSize: 22,
                                                                                                                                fontFamily: 'Btitr'
                                                                                                                            }}>
                                                                                                                            {":چکیده"}
                                                                                                                        </div>
                                                                                                                        <div
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                textAlign: "right",
                                                                                                                                fontSize: 19,
                                                                                                                                fontFamily: 'Bnazanin'
                                                                                                                            }}>
                                                                                                                            {value[0][2]}
                                                                                                                        </div>
                                                                                                                        <Button
                                                                                                                            variant="outlined"
                                                                                                                            color="primary"
                                                                                                                            style={{
                                                                                                                                marginRight: 5, fontSize: 22,
                                                                                                                                fontFamily: 'Btitr'
                                                                                                                            }}
                                                                                                                            onClick={() => this.handleClickOpen2(0, value[0][0].toString() + "," + value[1], this.state.similarity[0], option)}>
                                                                                                                            انتخاب
                                                                                                                        </Button>
                                                                                                                        {/* <div style={{textAlign:"right"}}> */}
                                                                                                                        {/* {value[0]} */}
                                                                                                                        {/* </div> */}

                                                                                                                    </CardHeader>
                                                                                                                </Card>

                                                                                                            )
                                                                                                        }
                                                                                                    }) : null

                                                                                                    }
                                                                                                </div>
                                                                                                {/* </CardHeader> */}
                                                                                                {/* </Card> */}
                                                                                            </Dialog>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="contaner_buttons">
                                                                                        <label
                                                                                            style={{
                                                                                                color: "black",
                                                                                                fontFamily: 'Bnazanin',
                                                                                                fontSize: 19,
                                                                                            }}> تعداد سند:</label>
                                                                                        <input style={{
                                                                                            marginRight: 16,
                                                                                            fontFamily: 'Bnazanin',
                                                                                            fontSize: 19,
                                                                                        }}
                                                                                            disabled
                                                                                            value={option[7]}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            } />


                                                                        {/*<label style={{color: "black"}}> احتمال*/}
                                                                        {/*    موضوع: {option1[0].toFixed(3)}</label>*/}
                                                                    </ CardHeader>
                                                                </Card>
                                                                {/* </  div> */}

                                                            </div>
                                                        )
                                                    })
                                                )
                                            } else {
                                                let key_replace = ""
                                                for (let i = 0; i < option1.length; i++) {
                                                    key_replace += option1[i] + "، ";
                                                }
                                                return (
                                                    <Card>
                                                        <CardHeader>

                                                            <p style={{
                                                                fontFamily: "Btitr",
                                                                fontSize: 20,
                                                            }}>
                                                                واژه‌های کلیدی حوزه:
                                                            </p>
                                                            <textarea
                                                                // className={styles.Input}
                                                                style={{
                                                                    width: "100%", fontFamily: "Bnazanin",
                                                                    fontSize: 22,
                                                                }}
                                                                name='textToHighlight'
                                                                value={key_replace}
                                                            // onChange={event => this.setState({ textToHighlight: event.target.value })}
                                                            />
                                                            {/* //<div style={{marginTop:"6%",width:"100%", display: 'flex', justifyContent: "center"}}>
                                    //<Button
                                       // className="button"
                                       // style={{fontFamily:"Btitr", fontSize:19,width:"20%",backgroundColor: "rgb(151,75,177)"}}
                                       // onClick={() => this.DownloadData()}
                                    // onClick={this.handleSubmit}
                                    >
                                     //  دریافت شواهد
				    //</Button>
                               // </div> */}
                                                        </CardHeader>

                                                    </Card>
                                                )


                                            }
                                        })

                                            : null),
                                    ]

                                }


                                {/* This Button uses a Font Icon, see the installation instructions in the Icon component docs. */}

                                {/* <Charts/>
                 <label style={{color:"black"}}> برچسب:</label>
                 <input style={{marginRight:"2%"}}
                                                    //    style={{width: "100%",marginRight:"1%"}}
                                                        // value={this.state.NWord}
                                                    //    onChange={this.handleChange1}/>
                                                    /> */}

                                {/* <GridItem xs={12} sm={12} md={20}>
          <Card chart>
            <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
           </ CardHeader>
           </Card> */}
                                {/* </  GridItem>                     */}
                            </CardBody>
                        </Card>


                    </GridItem>

                </GridContainer>

            </div>
        );
        // }
        // else
        // return (
        //     <h1 style={{color: '#000000',textAlign: 'center',fontFamily:'Btitr',fontSize:45}}>
        //         ابتدا در حساب خود وارد شوید
        //     </h1>

        // );

    }

    // showimage(){
    //     return(
    //         <img style={{width: '100%', height: '100%'}} src= {"image/lda"+this.state.ShowImage+".png" } />
    //     )
    // }
    sentLDAData() {
        // this.setState({
        //     ShowImage: null,
        // });
        // alert("hello");
        // if(!this.state.checked1 && !this.state.checked2)


        // this.setState({
        //     input: null,
        // });
        if (this.state.checked1) {
            if (this.state.NTopic == 0) {
                alert("تعداد موضوع را مشخص کنید")
            } else if (this.state.NWord == 0) {
                alert("تعداد واژه را مشخص کنید")
            } else {

                this.setState({
                    response: null,
                    Load: true,
                });
                //                fetch("http://conalysis.ihcs.ac.ir:8080/get_query", {

                fetch("http://conalysis.ihcs.ac.ir:8080/get_query", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        subject: this.state.value4,
                        minyear: this.state.min,
                        maxyear: this.state.max,
                        ntopic: this.state.NTopic,
                        nword: this.state.NWord,
                        email: this.props.location.state.email,
                        type: '1',
                    }),
                })
                    .then((response) => response.json())
                    .then((responseJson) => {

                        // console.log(responseJson[1][0]);
                        // console.log(responseJson[1][0][0]);
                        // if(responseJson.d==="done↵"){
                        console.log(responseJson);

                        this.setState({
                            response: responseJson,
                            Load: false,
                        });
                        console.log(this.state.input)
                        for (var i = 0; i < this.state.response.length; i++) {
                            this.setState({ input: [...this.state.input, 0] })
                            // var input1 = [...this.state.input];

                            //                                                               input1.splice(i, 1, 0);
                            //                                                               this.setState({
                            //                                                                   input:input1
                            //                                                               });
                        }
                        console.log(this.state.input)
                        // }
                        // var reader = new FileReader();
                        // reader.readAsDataURL(responseJson);
                        // reader.onloadend = function() {
                        //     var base64data = reader.result;
                        //     console.log(base64data);
                        // }
                        // window.location.href="/dashboard";
                        // return (<Link to="/dashboard"/>);
                        // alert(responseJson);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        } else if (this.state.checked2) {
            console.log(this.state.value4);
            console.log(this.state.value2);
            if (this.state.NTopic == 0) {
                alert("تعداد موضوع را مشخص کنید")
            } else if (this.state.NWord == 0) {
                alert("تعداد واژه را مشخص کنید")
            } else {
                this.setState({
                    response: null,
                    Load: true,
                });
                //                fetch("http://conalysis.ihcs.ac.ir:8080/get_query", {

                fetch("http://conalysis.ihcs.ac.ir:8080/get_query", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        subject: this.state.value4,
                        year: this.state.value2,
                        ntopic: this.state.NTopic,
                        nword: this.state.NWord,
                        email: this.props.location.state.email,
                        type: '2',
                    }),
                })
                    .then((response) => response.json())
                    .then((responseJson) => {
                        console.log(responseJson);
                        // if(responseJson.d==="done↵"){


                        this.setState({
                            response: responseJson,
                            Load: false,
                        });
                        console.log(this.state.response)
                        this.setState({
                            input: []
                        })
                        for (var i = 0; i < this.state.response.length; i++) {
                            this.setState({ input: [...this.state.input, 0] })
                            // var input1 = [...this.state.input];

                            //                                                               input1.splice(i, 1, 0);
                            //                                                               this.setState({
                            //                                                                   input:input1
                            //                                                               });
                        }
                        console.log(this.state.input)
                        // }
                        // var reader = new FileReader();
                        // reader.readAsDataURL(responseJson);
                        // reader.onloadend = function() {
                        //     var base64data = reader.result;
                        //     console.log(base64data);
                        // }
                        // window.location.href="/dashboard";
                        // return (<Link to="/dashboard"/>);
                        // alert(responseJson);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        } else if (this.state.checked3) {
            this.openInNewTab(`/material-dashboard-react/static/LDAVisualization-${this.state.NTopic}-${this.state.value4}.html`)
        } else {
            alert("تعیین زمان یا بازه زمانی انتشار متون علمی را انتخاب کنید")

        }

    }

    sentlabel() {
        this.setState({
            ShowImage: null,
        });
        // alert("hello");
        if (this.state.checked1) {
            console.log(this.state.value4);
            console.log(this.state.min);
            console.log(this.state.max)

            fetch("/setlabel", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    subject: this.state.value4,
                    minyear: this.state.min,
                    maxyear: this.state.max,
                    ntopic: this.state.NTopic,
                    nword: this.state.NWord,
                    label: "Asd2",
                    qtopic: 1,
                    type: '1',
                }),
            })
                .then((response) => response.text())
                .then((responseJson) => {
                    console.log(responseJson);


                    this.setState({
                        response: responseJson,
                    });


                })
                .catch((error) => {
                    console.log(error);
                });
        } else if (this.state.checked2) {
            console.log(this.state.value4);
            console.log(this.state.value2);
            console.log(this.state.NTopic);
            console.log(this.state.NWord);
            // console.log(this.state.value2);
            fetch("/setlabel", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    subject: this.state.value4,
                    year: this.state.value2,
                    ntopic: this.state.NTopic,
                    nword: this.state.NWord,
                    label: "Asd",
                    qtopic: 1,
                    type: '2',
                }),
            })
                .then((response) => response.text())
                .then((responseJson) => {
                    console.log(responseJson);


                    this.setState({
                        ShowImage: responseJson,
                    });

                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }

    DownloadData() {
        // const blob = res.blob();
        // download(blob, this.state.lastClicked.name + '.docx');
        // const res =  fetch("/download_sample_data", {
        //         method: "POST",
        //         headers: {
        //             // Accept: "application/json",
        //             "Content-Type": "application/octet-stream",
        //         },
        //         //   body: JSON.stringify({
        //             // email:this.props.location.state.email
        //         // }),
        //     }).then((response) => {

        //     })
        //        download('http://conalysis.ihcs.ac.ir:8080/data/' + this.props.location.state.email + '.csv')

        download('http://conalysis.ihcs.ac.ir:8080/data/' + this.props.location.state.email + '.csv')


        // fetch("/download_sample_data", {
        //     method: "POST",
        //     headers: {
        //         Accept: "application/json",
        //         "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify({
        //         email:this.props.location.state.email,
        //         // type:this.props.location.state.email,
        //     }),
        // })
        //     .then((response) => response.json())
        //     .then((responseJson) => {
        //         console.log(responseJson.url);
        //         // if(responseJson.d==="done↵"){
        //             // {url: "http://localhost:5000/data/شواهد.csv"}
        //             download('http://localhost:5000/data/شواهد.csv')

        //     })
        //     .catch((error) => {
        //         console.log(error);
        //     });
        // console.log(response.json)
        // const blob = response.blob();
        // download(response.json.url)
        // download('http://localhost:5000/image/lda%D9%85%D8%AF%DB%8C%D8%B1%DB%8C%D8%AA%20%D8%AD%D8%B3%D8%A7%D8%A8%D8%AF%D8%A7%D8%B1%DB%8C138013803.png');
        // window.open('http://localhost:5000/image/lda%D9%85%D8%AF%DB%8C%D8%B1%DB%8C%D8%AA%20%D8%AD%D8%B3%D8%A7%D8%A8%D8%AF%D8%A7%D8%B1%DB%8C138013803.png');


    }

    getLDAData() {
        // alert("hello");
        if (this.state.checked1) {
            console.log(this.state.value);
            console.log(this.state.min);
            console.log(this.state.max)
        } else if (this.state.checked2) {
            console.log(this.state.value);
            console.log(this.state.value2);

            fetch("/test", {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
                .then((response) => response.text())
                .then((responseJson) => {
                    console.log(responseJson);

                    this.setState({
                        ht: responseJson.toString(),
                    });
                    var dynamic_html = document.getElementById("dynamic_html");
                    dynamic_html.innerHTML = responseJson;
                    // window.location.href="/dashboard";
                    // return (<Link to="/dashboard"/>);
                    // alert(responseJson);
                })

                .catch((error) => {
                    console.log(error);
                });
        }


    }

    check22() {
        if (this.state.action) {
            //   console.log("entered");
            return (
                // <BrowserRouter>
                <Redirect
                    to={{
                        pathname: "/",
                        // state: {
                        //   token: this.state.token,
                        //   UserName: this.state.UserName,
                        // },
                    }}
                />
                // </BrowserRouter>
            );
        }
    }

}

export default ReactFontFace(LDA, fontConfig);

